import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MainHeaderMenuService {
  visible: boolean;

  constructor() {
    this.visible = false;
  }

  hide() {
    //////////
    this.visible = false;
  }

  show() {
    ////////
    this.visible = true;
  }
}
